import React from "react";
import { motion } from "framer-motion";
import Footers from "./Footer";
import Navbar from "./Navbar";

const Blog = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="page-wraper"
      style={{ background: "#fff" }}
    >
      <Navbar />
      <div className="page-content">
        <div
          className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
          data-stellar-background-ratio="0.5"
          style={{
            backgroundImage:
              "url(assets/pic/blogggg.jpg)",
          }}
        >
          <div className="overlay-main bg-black opacity-07"></div>
          <div className="container">
            <div className="wt-bnr-inr-entry">
              <div className="banner-title-outer">
                <div className="banner-title-name">
                  <h2 className="text-white"> Blog</h2>
                </div>
              </div>
              <div>
                <ul className="wt-breadcrumb breadcrumb-style-2">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li> Blog</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="section-full p-t80 p-b50">
          <div className="container">
            <div>
              <div className="news-listing">
                <div className="col-12">
                  <div className="row g4">
                    <div className="col-lg-4 col-md-6 mb-3">
                      <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                        className="blog-post blog-md date-style-1 clearfix "
                        style={{
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                          transition: "box-shadow 0.3s ease-in-out",
                          background:"#141414ba"
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.boxShadow =
                            "0px 6px 15px rgba(0, 0, 0, 0.2)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.boxShadow =
                            "0px 4px 10px rgba(0, 0, 0, 0.1)")
                        }
                      >
                        <div className="wt-post-media wt-img-effect zoom-slow relative">
                          <a className="block relative">
                            <img src="/assets/pic/INSPIRATION1.webp" alt="" />
                            <a href="/Blogdetail">
                              <div
                                className="absolute top-2 right-2 text-black text-xs tracking-widest font-bold py-2 px-3 shadow-md border-gray-300 uppercase rotate-90"
                                style={{
                                  right: "-25px",
                                  top: "41px",
                                  transform: "rotate(270deg)",
                                  color: "white",
                                  border: "2px solid #fff",
                                }}
                              >
                                SEE MORE
                              </div>
                            </a>
                          </a>
                        </div>
                        <div className="p-a30 " >
                          <div className="wt-post-meta">
                            <ul>
                              <li className="post-author">
                                <i className="fa fa-user" style={{color:'#fff'}}></i>
                                <a href="" className="text-white">
                                  20 November 2024
                                </a>
                              </li>
                              <li className="post-comment">
                                <i className="fa fa-comments" style={{color:'#fff'}}></i>
                                <a href="">
                                  <span className="text-white">CraftMyspace</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div className="wt-post-title">
                            <h4 className="post-title">
                              <a href="">
                                CraftMySpace Fitted Furniture Storage Solutions
                              </a>
                            </h4>
                          </div>
                          <div className="wt-post-text">
                            <p
                              style={{
                                fontFamily: "sans-serif",
                                color: "#7c7c7c",
                              }}
                            >
                              CraftMySpace fitted furniture storage solutions
                              blend style and functionality to maximize your
                              space efficiently. Designed with precision, our
                              bespoke storage solutions cater to your unique
                              needs, whether for bedrooms, living rooms, or
                              home offices. With a focus on high-quality
                              craftsmanship and modern aesthetics, we transform
                              cluttered spaces into organized, elegant
                              interiors. Experience seamless integration, smart
                              storage, and timeless designs with CraftMySpace
                              expert solutions
                            </p>
                          </div>
                        </div>
                      </motion.div>
                    </div>
                     {/* COLUMN 2 */}
 <div className="col-lg-4 col-md-6 mb-3">
 <motion.div
   className="blog-post blog-md date-style-1 clearfix "
   style={{
     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
     transition: "box-shadow 0.3s ease-in-out",
       background:"#141414ba"
   }}
   onMouseEnter={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 6px 15px rgba(0, 0, 0, 0.2)")
   }
   onMouseLeave={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 4px 10px rgba(0, 0, 0, 0.1)")
   }
 >
 


   
   <div className="wt-post-media wt-img-effect zoom-slow relative">
<a  className="block relative">
<img src="/assets/pic/bloggg2.jpg" alt="" />
{/* "SEE MORE" Box on Image */}
<a  href="/Blogdetail">
<div className="absolute top-2 right-2  text-black text-xs tracking-widest font-bold py-2 px-3 shadow-md  border-gray-300 uppercase rotate-90" style={{right:'-25px',top:'41px',transform:'rotate(270deg)',color:'white',border:'2px solid #fff'}}>
SEE MORE
</div>
</a>
</a>
</div>
   <div className=" p-a30 ">
     <div className="wt-post-meta">
       <ul>
         {/* <li className="post-date"><span>Aug 2019</span></li> */}
         <li className="post-author">
           <i className="fa fa-user" style={{color:'#fff'}}></i>
           <a href="" className="text-white"> 28 April 2024</a>
         </li>
         <li className="post-comment">
           <i className="fa fa-comments" style={{color:'#fff'}}></i>
           <a href="">
             {" "}
             <span className="text-white">CraftMyspace</span>
           </a>
         </li>
       </ul>
     </div>
     <div className="wt-post-title">
       <h4 className="post-title">
         <a href="">
           The Advantages of Aluminum Profile Sliding
           Wardrobe Doors
         </a>
       </h4>
     </div>
     <div className="wt-post-text">
       <p
         style={{
           fontFamily: "sans-serif",
           color: "#7c7c7c",
         }}
       >
         Aluminum profile sliding wardrobe doors offer a
         sleek, modern, and space-saving solution for any
         home. Their lightweight yet durable construction
         ensures long-lasting performance while providing
         smooth and effortless operation. Unlike
         traditional hinged doors, sliding doors maximize
         space efficiency, making them ideal for compact
         rooms. The aluminum frame adds a touch of
         elegance and is resistant to rust, corrosion,
         and wear, ensuring minimal maintenance.{" "}
       </p>
     </div>
     
   </div>
 </motion.div>
</div>

{/* COLUMN 3 */}
<div className="col-lg-4 col-md-6 mb-3">
 <motion.div
   className="blog-post blog-md date-style-1 clearfix "
   style={{
     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
     transition: "box-shadow 0.3s ease-in-out",
       background:"#141414ba"
   }}
   onMouseEnter={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 6px 15px rgba(0, 0, 0, 0.2)")
   }
   onMouseLeave={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 4px 10px rgba(0, 0, 0, 0.1)")
   }
 >



   <div className="wt-post-media wt-img-effect zoom-slow relative">
<a  className="block relative">
<img src="/assets/pic/blogg3.jpg" alt="" />
{/* "SEE MORE" Box on Image */}
<a  href="/Blogdetail">
<div className="absolute top-2 right-2  text-black text-xs tracking-widest font-bold py-2 px-3 shadow-md  border-gray-300 uppercase rotate-90" style={{right:'-25px',top:'41px',transform:'rotate(270deg)',color:'white',border:'2px solid #fff'}}>
SEE MORE
</div>
</a>
</a>
</div>
   <div className=" p-a30 ">
     <div className="wt-post-meta">
       <ul>
         {/* <li className="post-date"><span>Aug 2019</span></li> */}
         <li className="post-author">
           <i className="fa fa-user" style={{color:'#fff'}}></i>
           <a href="" className="text-white"> 24 June 2024</a>
         </li>
         <li className="post-comment">
           <i className="fa fa-comments" style={{color:'#fff'}}></i>
           <a href="">
             {" "}
             <span className="text-white">CraftMyspace</span>
           </a>
         </li>
       </ul>
     </div>
     <div className="wt-post-title">
       <h4 className="post-title">
         <a href="">
           Stages When Ordering From CraftMySpace
         </a>
       </h4>
     </div>
     <div className="wt-post-text">
       <p
         style={{
           fontFamily: "sans-serif",
           color: "#7c7c7c",
         }}
       >
         When ordering from CraftMySpace, the process
         begins with an inquiry and consultation, where
         customers share their requirements, design
         preferences, and budget. Our expert designers
         then create custom concepts and 3D renders for
         approval. Once the design is finalized, we
         provide a detailed quotation, and upon approval,
         production begins with skilled artisans crafting
         each piece meticulously.
       </p>
     </div>

   </div>
 </motion.div>
</div>
{/* COLUMN 4 */}
<div className="col-lg-4 col-md-6 mb-3">
 <motion.div
   className="blog-post blog-md date-style-1 clearfix "
   style={{
     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
     transition: "box-shadow 0.3s ease-in-out",
       background:"#141414ba"
   }}
   onMouseEnter={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 6px 15px rgba(0, 0, 0, 0.2)")
   }
   onMouseLeave={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 4px 10px rgba(0, 0, 0, 0.1)")
   }
 >
 



   <div className="wt-post-media wt-img-effect zoom-slow relative">
<a  className="block relative">
<img src="/assets/pic/blogg4.jpg" alt="" />
{/* "SEE MORE" Box on Image */}
<a  href="/Blogdetail">
<div className="absolute top-2 right-2  text-black text-xs tracking-widest font-bold py-2 px-3 shadow-md  border-gray-300 uppercase rotate-90" style={{right:'-25px',top:'41px',transform:'rotate(270deg)',color:'white',border:'2px solid #fff'}}>
SEE MORE
</div>
</a>
</a>
</div>
   <div className="p-a30 ">
     <div className="wt-post-meta">
       <ul>
         {/* <li className="post-date"><span>Aug 2019</span></li> */}
         <li className="post-author">
           <i className="fa fa-user" style={{color:'#fff'}}></i>
           <a href="" className="text-white"> 5 November 2024</a>
         </li>
         <li className="post-comment">
           <i className="fa fa-comments" style={{color:'#fff'}}></i>
           <a href="">
             {" "}
             <span className="text-white">CraftMyspace</span>
           </a>
         </li>
       </ul>
     </div>
     <div className="wt-post-title">
       <h4 className="post-title">
         <a href="">
           Egger vs Kronospan MFC for Fitted Wardrobes:
           The Ultimate Comparison
         </a>
       </h4>
     </div>
     <div className="wt-post-text">
       <p
         style={{
           fontFamily: "sans-serif",
           color: "#7c7c7c",
         }}
       >
         When choosing between Egger and Kronospan MFC
         for fitted wardrobes, both brands offer
         high-quality, durable, and aesthetically
         appealing options. Egger MFC is known for its
         premium finishes, extensive color range, and
         superior scratch resistance, making it a
         preferred choice for high-end interiors.
       </p>
     </div>
    
   </div>
 </motion.div>
</div>

{/* COLUMN 5 */}
<div className="col-lg-4 col-md-6 mb-3">
 <motion.div
   className="blog-post blog-md date-style-1 clearfix "
   style={{
     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
     transition: "box-shadow 0.3s ease-in-out",
       background:"#141414ba"
   }}
   onMouseEnter={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 6px 15px rgba(0, 0, 0, 0.2)")
   }
   onMouseLeave={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 4px 10px rgba(0, 0, 0, 0.1)")
   }
 >




   <div className="wt-post-media wt-img-effect zoom-slow relative">
<a  className="block relative">
<img src="/assets/pic/blogg5.jpg" alt="" />
{/* "SEE MORE" Box on Image */}
<a  href="/Blogdetail">
<div className="absolute top-2 right-2  text-black text-xs tracking-widest font-bold py-2 px-3 shadow-md  border-gray-300 uppercase rotate-90" style={{right:'-25px',top:'41px',transform:'rotate(270deg)',color:'white',border:'2px solid #fff'}}>
SEE MORE
</div>
</a>
</a>
</div>
   <div className=" p-a30 ">
     <div className="wt-post-meta">
       <ul>
         {/* <li className="post-date"><span>Aug 2019</span></li> */}
         <li className="post-author">
           <i className="fa fa-user" style={{color:'#fff'}}></i>
           <a href="" className="text-white"> 27 November 2024</a>
         </li>
         <li className="post-comment">
           <i className="fa fa-comments" style={{color:'#fff'}}></i>
           <a href="">
             {" "}
             <span className="text-white">CraftMyspace</span>
           </a>
         </li>
       </ul>
     </div>
     <div className="wt-post-title">
       <h4 className="post-title">
         <a href="">
           The Ultimate Guide to Sliding Door Wardrobes:
           Transform Your Space Today!
         </a>
       </h4>
     </div>
     <div className="wt-post-text">
       <p
         style={{
           fontFamily: "sans-serif",
           color: "#7c7c7c",
         }}
       >
         A sliding door wardrobe is a stylish and
         space-saving solution that enhances both
         functionality and aesthetics in any room.
         Available in a variety of materials, finishes,
         and designs—from sleek mirrored panels to
         elegant wooden textures—these wardrobes can be
         customized to complement any interior style.{" "}
       </p>
     </div>
     
   </div>
 </motion.div>
</div>

{/* COLUMN 6 */}
<div className="col-lg-4 col-md-6 mb-3">
 <motion.div
   className="blog-post blog-md date-style-1 clearfix "
   style={{
     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
     transition: "box-shadow 0.3s ease-in-out",
       background:"#141414ba"
   }}
   onMouseEnter={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 6px 15px rgba(0, 0, 0, 0.2)")
   }
   onMouseLeave={(e) =>
     (e.currentTarget.style.boxShadow =
       "0px 4px 10px rgba(0, 0, 0, 0.1)")
   }
 >



   <div className="wt-post-media wt-img-effect zoom-slow relative">
<a  className="block relative">
<img src="/assets/pic/blogg6.jpg" alt="" />
{/* "SEE MORE" Box on Image */}
<a  href="/Blogdetail">
<div className="absolute top-2 right-2  text-black text-xs tracking-widest font-bold py-2 px-3 shadow-md  border-gray-300 uppercase rotate-90" style={{right:'-25px',top:'41px',transform:'rotate(270deg)',color:'white',border:'2px solid #fff'}}>
SEE MORE
</div>
</a>
</a>
</div>
   <div className=" p-a30 ">
     <div className="wt-post-meta">
       <ul>
         {/* <li className="post-date"><span>Aug 2019</span></li> */}
         <li className="post-author">
           <i className="fa fa-user" style={{color:'#fff'}}></i>
           <a href="" className="text-white">28 February 2024</a>
         </li>
         <li className="post-comment">
           <i className="fa fa-comments" style={{color:'#fff'}}></i>
           <a href="">
             {" "}
             <span className="text-white">CraftMyspace</span>
           </a>
         </li>
       </ul>
     </div>
     <div className="wt-post-title">
       <h4 className="post-title">
         <a href="">
           The Ultimate Guide to MFC Fitted Wardrobes:
           Stylish, Functional, and Affordable
         </a>
       </h4>
     </div>
     <div className="wt-post-text">
       <p
         style={{
           fontFamily: "sans-serif",
           color: "#7c7c7c",
         }}
       >
         MFC fitted wardrobes are the perfect blend of
         style, functionality, and affordability, making
         them a popular choice for modern homes. Made
         from Melamine Faced Chipboard (MFC), these
         wardrobes offer a sleek and durable finish,
         available in a wide range of colors, textures,
         and woodgrain effects to suit any interior.{" "}
       </p>
     </div>
   
   </div>
 </motion.div>
</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footers />
      <button className="scroltop">
        <span className="fa fa-angle-up relative" id="btn-vibrate"></span>
      </button>
    </motion.div>
  );
};

export default Blog;